'use client';


import Icon from '@/components/ui/AppIcon';

export interface Job {
  id: string;
  title: string;
  specialty: string;
  facilityType: string;
  location: string;
  payRange: string;
  shift: string;
  postedDate: string;
  roleType: string;
}

interface JobCardProps {
  job: Job;
}

export default function JobCard({ job }: JobCardProps) {
  return (
    <div className="bg-white p-6 rounded-xl border border-border hover:shadow-lg transition-all hover:-translate-y-0.5">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-xl font-semibold text-foreground mb-2">{job.title}</h3>
          <p className="text-sm text-muted-foreground">{job.facilityType}</p>
        </div>
        <span className="px-3 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
          {job.specialty}
        </span>
      </div>

      <div className="space-y-3 mb-6">
        <div className="flex items-center text-sm text-muted-foreground">
          <Icon name="MapPinIcon" size={16} className="mr-2 text-primary" />
          {job.location}
        </div>
        <div className="flex items-center text-sm text-muted-foreground">
          <Icon name="CurrencyDollarIcon" size={16} className="mr-2 text-primary" />
          {job.payRange}
        </div>
        <div className="flex items-center text-sm text-muted-foreground">
          <Icon name="ClockIcon" size={16} className="mr-2 text-primary" />
          {job.shift}
        </div>
        <div className="flex items-center text-sm text-muted-foreground">
          <Icon name="CalendarIcon" size={16} className="mr-2 text-primary" />
          Posted {job.postedDate}
        </div>
      </div>

      <button
        data-cal-namespace="medical"
        data-cal-link="team/inf/medical"
        data-cal-config='{"layout":"month_view","useSlotsViewOnSmallScreen":"true","theme":"light"}'
        className="w-full flex items-center justify-center px-6 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary/90 transition-colors"
      >
        Quick Apply
        <Icon name="ArrowRightIcon" size={16} className="ml-2" />
      </button>
    </div>
  );
}